import styled from 'styled-components';

import { isNum, limitDecimal, titleCaseReplace } from '@utils/helpers';
import { formatArea } from '@utils/measurementSystem';
import { useProject } from '@contexts/Project.context';

const Details = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 10px;
	padding-top: 20px;
	padding-bottom: 20px;

	p {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		gap: 5px;
		font-size: 0.9em;
		font-weight: normal;
		line-height: 1.1;
		text-transform: none;
		margin: 0;

		span:first-child {
			text-transform: capitalize;
			color: ${p => p.theme.colors.textAccent};
		}

		i {
			display: inline-block;
			font-style: normal;
			min-width: 2em;
			text-align: right;
		}
	}
`;

const calculateAvgGsd = pixelDimension => {
	if (!pixelDimension?.length) return;
	const [width, height] = pixelDimension;
	return (width + height) / 2;
};

const getGsdInCm = project => {
	let { gsd, pixel_dimension } = project ?? {};
	gsd = isNum(gsd) ? gsd : calculateAvgGsd(pixel_dimension);

	if (gsd > 0) return limitDecimal(gsd * 100);
	else return null;
};

const SidebarSummary = () => {
	const { project, projectMode } = useProject();
	if (!project) return null;

	const [area, areaUnit] = formatArea(project?.area);
	const gsd = getGsdInCm(project);

	return (
		<Details>
			<Item label="Project Type" value={titleCaseReplace(projectMode)} />
			<Item label="Area" value={area} unit={areaUnit} />
			<Item label="GSD" value={gsd} unit={'cm'} />
		</Details>
	);
};
export default SidebarSummary;

const Item = ({ label, value, unit }) => {
	if (!value) return null;

	return (
		<p>
			<span>{label}</span>
			<span>
				{value} {unit && <i>{unit}</i>}
			</span>
		</p>
	);
};
